import CustomButton from "../../../Common/CustomButton";
import UserAvatarMenu from "../../../Feed/Menus/UserAvatarMenu";
import { Box, styled, Typography, useMediaQuery } from "@mui/material";
import { upgradePlan } from "../SVG";
import { useHistory } from "react-router-dom";
import { userProfile } from "../../../../libs/UserProfile";
import ProfileEndpoint from "../../../../libs/ProfileEndpoint";
import { logEvent } from "@amplitude/analytics-browser";
import { useEffect, useState } from "react";
import BizdevAgentEndpoint from "../../../../libs/BizdevAgentEndpoints";
import FT from "../../../../libs/FT";

interface IQuotaInfo {
  userInfo: UserInfo | null;
  userQuota: any;
  navigateToProfileEdit: (
    event: React.MouseEvent<Element>,
    path: string
  ) => Promise<void>;
}

export const QuotaInfo = ({
  userInfo,
  userQuota,
  navigateToProfileEdit,
}: IQuotaInfo) => {
  const isTab = useMediaQuery("(min-width:769px) and (max-width:1023px)");
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Box
        sx={{ height: "1px", backgroundColor: "#292929", width: "100%" }}
      ></Box>
      {userQuota && (
        <Typography
          sx={{ color: "#b7b7b7", fontSize: "12px", lineHeight: "16px" }}
        >
          You have <span style={{ color: "#FEFEFE" }}>{userQuota}</span> API
          quota left
        </Typography>
      )}

      {userInfo?.accountSubscriptionPlan?.subscriptionPlan === "Pro" ? (
        <Typography
          sx={{
            color: "#fefefe",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: 500,
          }}
        >
          {upgradePlan} Pro
        </Typography>
      ) : (
        <CustomButton
          size={isTab ? "small" : "medium"}
          type="grey"
          preImg={upgradePlan}
          onClick={(e: React.MouseEvent<Element>) =>
            navigateToProfileEdit(e, "/subscription")
          }
        >
          Upgrade to Pro
        </CustomButton>
      )}
    </Box>
  );
};

const AccountInfo = ({ isPublic }: { isPublic: boolean }) => {
  const [userQuota, setUserQuota] = useState();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const history = useHistory();
  const userCache = userProfile(localStorage);
  const isTab = useMediaQuery("(min-width:769px) and (max-width:1023px)");

  const navigateToProfileEdit = async (
    event: React.MouseEvent<Element>,
    path: string
  ) => {
    const r = await ProfileEndpoint.generateTokenForEdit(userCache.userId());
    logEvent("ProfileEdit", userCache.userId());
    history.push(`/profile/edit/${r.token}${path}`);
  };

  const fetchUserInfo = async () => {
    try {
      const response = await FT.get(userCache.userId(), {});
      if (response) {
        setUserInfo(response);
      }
    } catch (err) {
      // console.error("Failed to fetch user info:", err);
    }
  };

  const fetchUserQuota = async () => {
    try {
      const data = await BizdevAgentEndpoint.getRateLimitInfo();
      setUserQuota(data.usage.remaining);
    } catch (error) {
      console.error("Failed to fetch dashboard data:", error);
    }
  };

  useEffect(() => {
    fetchUserInfo();
    fetchUserQuota();
    // eslint-disable-next-line
  }, []);

  return (
    <Root>
      {!isPublic && userInfo && (
        <UserAvatarMenu
          navigateToProfileEdit={navigateToProfileEdit}
          userInfo={userInfo}
          userQuota={userQuota}
        />
      )}
      {!isTab && (
        <QuotaInfo
          userInfo={userInfo}
          userQuota={userQuota}
          navigateToProfileEdit={navigateToProfileEdit}
        />
      )}
    </Root>
  );
};

export default AccountInfo;

export interface UserInfo {
  name: string;
  emailAddress: string;
  [key: string]: any;
  accountSubscriptionPlan?: AccountSubscriptionPlan;
}

export interface AccountSubscriptionPlan {
  customerId: string;
  currency: string;
  amountPaid: string;
  subscriptionId: string;
  billingInterval: string;
  subscriptionPlan: string;
}

const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  alignItems: "flex-start",
  position: "fixed",
  bottom: "0px",
  zIndex: 99,
  background: "#121212",
  padding: "20px 0",
  [theme.breakpoints.down(769)]: {
    background: "none",
  },
}));
